import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AxiosService from "utils/AxiosService";

function UseLoginHook() {
  const [loginLoader, setLoginLoader] = useState(false);
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const navigate = useNavigate();

  // ✅ LOGIN
  const loginUser = async (payload) => {
    setLoginLoader(true);
    try {
      const res = await AxiosService.post("/auth/login", payload);
      if (res.status === 200) {
        toast.success(res.data.message);
        setToken(res.data.token);
        setUser(res.data.user);

        // Save session
        sessionStorage.setItem("token", res.data.token);
        localStorage.setItem("user", JSON.stringify(res.data.user));

        // Redirect based on role
        if (res.data.user.role === "vendor") navigate("/vendor-dashboard");
        else if (res.data.user.role === "admin") navigate("/admin-dashboard");
        else if (res.data.user.role === "employee")
          navigate("/product-management");
        else navigate("/");

        return true;
      }
      return false;
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || "Login failed");
      return false;
    } finally {
      setLoginLoader(false);
    }
  };

  // ✅ FORGOT PASSWORD (Send OTP)
  const forgotPassword = async (payload) => {
    setLoginLoader(true);
    try {
      const res = await AxiosService.post("/auth/forgot-password", payload);
      if (res.status === 200) {
        toast.success(res.data.message || "OTP sent successfully");
        return true;
      }
      return false;
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || "Failed to send OTP");
      return false;
    } finally {
      setLoginLoader(false);
    }
  };

  // ✅ RESET PASSWORD (Verify OTP & Update Password)
  const resetPassword = async (payload) => {
    setLoginLoader(true);
    try {
      const res = await AxiosService.post("/auth/reset-password", payload);
      if (res.status === 200) {
        toast.success(res.data.message || "Password reset successful");
        navigate("/whats-app-authentication");
        return true;
      }
      return false;
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || "Reset password failed");
      return false;
    } finally {
      setLoginLoader(false);
    }
  };

  return {
    loginUser,
    forgotPassword,
    resetPassword,
    loginLoader,
    user,
    token,
  };
}

export default UseLoginHook;
